module.exports = __webpack_public_path__ + "img/thumb_27.8474b29f.jpg";